export const createHtmlRenderState = () => ({
    style: {},
    transform: {},
    transformOrigin: {},
    vars: {},
});
//# sourceMappingURL=create-render-state.js.map